import { exportFile } from 'common/api/quotes';

import { SET_IS_DOWNLOADING } from '../actionTypes';
import { proposalsActions } from '../reducer';

export default ({
        company = '',
        month = null,
        orderBy = 'created_at',
        page = 0,
        pageSize = 25,
        rateName = 'all',
        searchText,
        sortBy = null,
        year = null,
    } = {}) =>
    (dispatch) => {
        dispatch(proposalsActions[SET_IS_DOWNLOADING](true));

        exportFile({
            company,
            month,
            orderBy,
            page: page + 1,
            perPage: pageSize,
            rateName,
            searchText,
            sortBy,
            year,
        })
            .then((response) => {
                dispatch(proposalsActions[SET_IS_DOWNLOADING](false));
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Cotizaciones.csv`);
                document.body.appendChild(link);
                link.click();
                dispatch(proposalsActions[SET_IS_DOWNLOADING](false));
            })
            .catch(() => dispatch(proposalsActions[SET_IS_DOWNLOADING](false)));
    };
